<template>
    <div class="vote-box">
        <div class="build-bar">
            <el-button type="primary" @click="addRow()">添加</el-button>
        </div>
        <div class="build-table">
            <el-table :data="tableData" style="width: 100%" height="100%">
                <el-table-column type="expand">
                    <template slot-scope="props">
                        <p style="color:#17b2fe;font-size:1vw;margin-bottom: 1vh;">{{props.row.contents}}</p>
                        <el-form label-position="left" class="demo-table-expand" >
                            <el-form-item :label="item.optionss" v-for="(item,index) in props.row.voteOptionsList" :key="index" label-width="50px" :label-position="'right'">
                                <div style="width:100%;display:flex;align-items: center;">
                                    <span style="font-size:0.8vw;margin-right:1vh;">{{ item.optionsContent }}</span>
                                    <el-image 
                                        v-if="item.optionsPhoto && ''!=item.optionsPhoto"
                                        style="width: 100px; height: 100px"
                                        :src="httpCtx+item.narrowPhoto" 
                                        :preview-src-list="[httpCtx+item.optionsPhoto]">
                                    </el-image>
                                </div>
                            </el-form-item>
                        </el-form>
                    </template>
                </el-table-column>
                <template slot="empty">
                    <p>{{dataText}}</p>
                </template>
                <el-table-column label="序号" width="80">
                    <template slot-scope="scope">
                        <span>{{ scope.row.index }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="标题" prop="title">
                    <template slot-scope="scope">
                        <span>{{ scope.row.title }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="投票数" prop="type">
                    <template slot-scope="scope">
                        <span>{{ scope.row.type }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="投票开始时间">
                    <template slot-scope="scope">
                        <span>{{ scope.row.startDate }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="投票截止时间" prop="limitDate">
                    <template slot-scope="scope">
                        <span>{{ scope.row.limitDate }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                    <el-button size="mini" v-if="scope.row.isEdit" type="success" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                    <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                    <el-button size="mini" @click="erCode(scope.$index, scope.row)">二维码</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 表单列表 -->
            <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[5, 10, 20, 50]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalItems"
            ></el-pagination>
        </div>
        <!-- 新增窗口 -->
        <el-dialog
            :title="dialogTitle"
            :visible.sync="addFormVisible"
            center
            :append-to-body="true"
            :lock-scroll="false"
            class="add-form"
            width="35%"
        >
            <el-form
            :model="form"
            ref="form"
            label-width="120px"
            :label-position="labelPosition"
            
            >
                <el-form-item label="投票标题：">
                    <el-input v-model="form.title"></el-input>
                </el-form-item>
                <el-form-item label="投票内容：">
                    <el-input type="textarea" v-model="form.contents"></el-input>
                </el-form-item>
                <el-form-item label="投票数：">
                    <el-input type="number" v-model="form.type"></el-input>
                </el-form-item>
                <el-form-item label="投票开始时间：">
                    <el-date-picker
                        v-model="form.startDate"
                        type="datetime"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="选择日期时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="投票时限：">
                    <el-date-picker
                        v-model="form.limitDate"
                        type="datetime"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="选择日期时间">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="投票规则：">
                    <el-input type="textarea" v-model="form.note"></el-input>
                </el-form-item>
                <el-form-item label="选项：">
                    <label class="layui-form-label">
                        <el-button @click="addQ" type="success" icon="el-icon-plus"></el-button>
                    </label>
                    <div class="questItem" id="opt_1" name="keyList" v-for="item in questOpt" :key="item.index" style="margin-top:1vh;">
                        <b :val="item.letter" style="font-weight: 700;margin-right:50px;" name="list.letter">{{item.optionss}}、</b>
                        <el-button :fatId="'opt_'+item.index" type="danger" size="mini" class="questDel" icon="el-icon-delete" @click="delOpt(item.optionss)"></el-button>
                        <div style="display:flex;justify-content: space-between">
                            <el-input type="textarea"  v-model="item.optionsContent" rows="4" class="opWord" style="width:calc( 100% - 150px )"></el-input>
                            <el-upload
                                class="avatar-uploader"
                                v-bind:action="uploadUrl"
                                :headers="uploadHead"
                                :data={type:233}
                                :objectBind='item.optionss'
                                :show-file-list="false"
                                :before-upload="photoBefore"
                                :on-success="photoSuccess">
                                <img v-if="item.optionsPhoto && ''!=item.optionsPhoto " :src="httpCtx+item.narrowPhoto" class="avatar">
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                        </div>
                        
                        <!-- <el-upload
                            class="upload-demo"
                            v-bind:action="uploadUrl"
                            :headers="uploadHead"
                            :data={type:213}
                            :objectBind='item.optionss'
                            :show-file-list="false"
                            :on-success="photoSuccess">
                                <i class="el-icon-upload" style="color:#36C635;font-size:56px;"></i>
                                <div class="el-upload__text">上传</div>
                        </el-upload> -->
                    </div>
                </el-form-item>
                <!-- <div class="layui-form-text answer" id="answer" >
                    <label class="layui-form-label">
                        <el-button @click="addQ" type="success" icon="el-icon-plus"></el-button>
                    </label>
                    <div class="questItem" id="opt_1" name="keyList" v-for="item in questOpt" :key="item.index">
                        <b :val="item.letter" style="font-weight: 700;margin-right:50px;" name="list.letter">{{item.optionss}}</b>
                        <el-button :fatId="'opt_'+item.index" type="danger" size="mini" class="questDel" icon="el-icon-delete" @click="delOpt(item.optionss)"></el-button>
                        <el-input type="textarea"  v-model="item.opWord" rows="3" class="opWord" ></el-input>
                    </div>
                </div> -->
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="addFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="sumbitAddRow('form')">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 二维码弹出框 -->
        <el-dialog
            :title="codeTit"
            :visible.sync="codeVis"
            center
            :append-to-body="true"
            :lock-scroll="false"
            width="30%"
            style="height:100%;"
        >
            <div class="erCode">
                <vue-qr :text="codeUrl" :size="300"></vue-qr>
                <!-- <p style="width:100%;text-align:center;">
                    <el-button type="primary" @click="downCode">确 定</el-button>
                </p> -->
            </div>
        </el-dialog>
    </div>
</template>

<script>
import myHttp from '../../untils/port';
import util from '../../untils/util';
import vueQr from 'vue-qr'
import base from '../../untils/base';
export default {
    components: {
            vueQr
    },
    data(){
        return{
            form:{
                id:'',
                groupId:'',
                userType:'',
                title:'',
                contents:'',
                type:'1',
                startDate:util.myTime.getCurTime()+' 00:00:00',
                limitDate:util.myTime.getCurTime()+' 23:59:59',
                createBy:util.session.get('user').id,
                jsonString:'',
                note:''
            },
            options:[],
            groupId:'',
            // zim:[],
            questOpt:[{
                id:"",
                optionss:1,
                optionsContent:'',
                optionsPhoto:'',
                allUrl:undefined,
            }],
            labelPosition: 'right', // 添加设备弹出框position属性
            dataText:'数据加载中...',
            addFormVisible:false,
            dialogTitle:'',
            currentPage: 1, // 表单列表默认页
            pageSize: 10, // 表单列表默认显示数
            totalItems: 0, // 表单列表全部长度
            tableData:[],//列表数据
            httpCtx:base.httpCtx,
            //uploadUrl:base.url+"/upload/uploadPhoto",//上传地址  upload/uploadPhotosAndThumbnail
            uploadUrl:base.url+"/upload/uploadPhotosAndThumbnail",//上传地址
            uploadHead:{  //上传接口header
                accessToken:util.session.get('token')
            },
            //二维码
            codeVis:false,
            codeUrl:'',
            codeTit:'',
            loading:undefined,
        }
    },
    mounted(){
        this.groupId = util.session.get('groupId')
        this.getData()
    },
    methods:{
        handleSizeChange(val) {
            this.pageSize = val
            this.handleCurrentChange(this.currentPage)
        },
        handleCurrentChange(val) {
            // console.log(`当前页: ${val}`)
            this.currentPage = val
            this.getData()
        },
        // 监控当前页码
        currentChangePage() {
            this.getData()
        },
        //获取列表
        getData(){
            var that = this
            myHttp.selectVoteProjectPersonListPage({
                groupId:this.groupId,
                pageNum:this.currentPage,
                pageSize:this.pageSize
            }).then(function(resp){
                console.log(resp)
                if(resp.data.code=='200'){
                    var list = resp.data.data.PageInfo.list||0
                    for(var i=0;i<list.length;i++){
                        list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
                        list[i].isEdit = new Date(list[i].startDate).getTime() <= new Date().getTime()?false:true
                    }
                    that.tableData = list
                    that.totalItems = resp.data.data.PageInfo.total||0
                    if (that.tableData.length == 0) {
                        that.dataText = '暂无数据'
                    }
                }else{
                    that.$message.error(resp.data.msg)
                    that.dataText = '暂无数据'
                }
            })
        },
        //添加
        addRow(){
            this.dialogTitle = '新增投票'
            this.addFormVisible = true
            this.form = {
                id:'',
                groupId:'',
                userType:'',
                title:'',
                contents:'',
                type:'1',
                startDate:util.myTime.getCurTime()+' 00:00:00',
                limitDate:util.myTime.getCurTime()+' 00:00:00',
                createBy:util.session.get('user').id,
                jsonString:'',
                note:''
            }
            this.questOpt = [{
                id:"",
                optionss:1,
                optionsContent:'',
                optionsPhoto:'',
            }]
        },
        //编辑
        handleEdit(index,row){
            this.dialogTitle = '修改投票'
            this.addFormVisible = true
            this.form.id = row.id
            this.form.title = row.title
            this.form.contents = row.contents
            this.form.type = row.type
            this.form.startDate = row.startDate,
            this.form.limitDate = row.limitDate,
            this.form.optionsContent = ''
            this.form.jsonString = ''
            this.form.note = row.note
            this.questOpt = row.voteOptionsList

        },
        //删除  handleDelete
        handleDelete(index,row){
            var that = this
            this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                myHttp.deleteVoteProjectPerson({
                    id: row.id
                }).then(function(resp) {
                    if (resp.data.code == '200') {
                    that.$message.success('删除成功')
                    that.getData()
                    } else {
                    that.$message.error(resp.data.msg)
                    }
                })
            })
        },
        /**弹出框添加 */
        photoBefore(file){
            this.loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
        },
        //图片上传
        photoSuccess(res,file,opt,index){
            this.loading.close();
            if(res.code==200){
                var baseUrl = res.data.savePhotoUrls
                var url = res.data.saveThumbnailUrls
                for(var i=0;i<this.questOpt.length;i++){
                    if(this.questOpt[i].optionss == index){
                        this.questOpt[i].narrowPhoto = url
                        this.questOpt[i].optionsPhoto = baseUrl
                    }
                }
                var list = this.questOpt
                this.questOpt = []
                this.questOpt = list
            }
        },

        //添加答案
        addQ(){
            var optionss = 1;
            var length = this.questOpt.length;
            if(length>0){
                var cur = this.questOpt[length-1].optionss;
                optionss = parseInt(cur) + 1;
            }
            var option = {
                id:'',
                optionss:optionss,
                optionsContent:''
            }
            this.questOpt.push(option);
        },
        //删除
        delOpt(val){
            var old = this.questOpt;
            var list = [];
            var setId = 1;
            for(var i=0;i<old.length;i++){
                if(val!=old[i].optionss){
                    old[i].optionss = setId;
                    list.push(old[i]);
                    setId++;
                }
            }
            this.questOpt = list;
        },
        //返回
        goBack(){
            this.$router.go(-1);
        },
        //提交
        sumbitAddRow(){
            var that = this;
            var list = this.questOpt;
            var obj = [];
            for(var i=0;i<list.length;i++){
                var sub = { id:'',optionss: '', optionsContent: '',narrowPhoto:'' }
                sub.id = list[i].id;
                sub.optionss = list[i].optionss;
                sub.optionsPhoto = list[i].optionsPhoto;
                sub.optionsContent = list[i].optionsContent;
                sub.narrowPhoto = list[i].narrowPhoto;
                obj.push(sub);
                // var isAns = list[i].coverType;
                // if (isAns == '0' && this.form.answer == '') {
                //     this.form.answer = sub.opOption;
                // } else if (isAns == '0' && this.form.answer != '' && this.form.questionType == '1' || isAns == 0 && this.form.answer != '' && this.form.questionType == '3') {
                //     isFlag = false;
                //     this.$message.error('单选题或者判断题只能有一个答案');
                //     break;
                // } else if (isAns == 0) {
                //     this.form.answer = this.form.answer + "," + sub.opOption;
                // }
            }
            // if (obj.answer == '') {
            //     this.$message.error('请选择答案');
            //     return;
            // } else if (!isFlag) {
            //     return;
            // } else{
                this.form.groupId = this.groupId
                this.form.userType = util.session.get('roleId')

                this.form.jsonString = JSON.stringify(obj);
                if(this.form.id==''){
                    this.form.createBy = util.session.get('user').id
                    myHttp.postVoteProjectPerson(this.form).then(function (resp) {
                        if (resp.data.code == "200") {
                            that.$message.success('添加成功');
                            that.addFormVisible = false
                            that.getData()
                            // that.reload();
                        } else {
                            that.$message.error(resp.data.msg);
                            return;
                        }
                    }, function (error) {
                        that.$message.error("服务器繁忙，请稍候再试");
                    });
                }else{
                    this.form.updateBy = util.session.get('user').id
                    myHttp.updateVoteProjectPerson(this.form).then(function (resp) {
                        if (resp.data.code == "200") {
                            that.$message.success('添加成功');
                            that.addFormVisible = false
                            that.getData()
                        } else {
                            that.$message.error(resp.data.msg);
                            return;
                        }
                    }, function (error) {
                        that.$message.error("服务器繁忙，请稍候再试");
                    });
                }
            // }
        },

        //展示二维码
        erCode(index,row){
            this.codeTit = row.title
            this.codeVis = true
            //this.codeUrl = 'http://sitesweb.tongsheng01.com/wisdom/data/vote.html?id='+row.id
            this.codeUrl = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxd843fb7b249a7b44&redirect_uri=http://sitesweb.tongsheng01.com/wisdom/data/vote.html?id='+row.id+'&c=entry&rid=258&do=index&m=tyzm_diamondvote&wxref=mp.weixin.qq.com&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect'
            // this.codeTit = row.location
        },

    }
}
</script>

<style scoped>
    .vote-box{
        width: 100%;
        height: 100%;
        position: relative;
        padding: 1vh;
    }
    .build-bar {
        width: 100%;
        position: relative;
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 8vh;
        border-bottom: 3px solid #17b2fe;
        background: #fff;

    }
    .build-bar span {
        margin-left: 30px;
        white-space: nowrap;
        display: inline-block;
    }

    .build-bar > .el-input {
        width: 200px;
        font-size: 12px;
    }

    .build-bar > .el-button {
        margin-left: 30px;
        background-color: #17b2fe;
        border-color: #17b2fe;
    }

    .build-bar > .el-button:last-child {
        margin-right: 20px;
    }

    .build-table {
        position: relative;
        width: 100%;
        background: #fff;
        height: calc( 100% - 13vh );
    }

    
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 100px;
        height: 100px;
        line-height: 100px;
        text-align: center;
    }
    .avatar {
        width: 100px;
        height: 100px;
        display: block;
    }
    .erCode{
        width: 100%;
        height: 100%;
        position: relative;
        display: flex;
        justify-content: center;
        justify-items: center;
        align-content: center;
        align-items: center;
        flex-wrap: wrap;
    }
</style>

<style>
    .vote-box .el-form-item__label{
        font-size: 0.8vw;
    }
    .vote-box .el-form-item{
        margin: 0;
        margin-top: 1vh;
    }
    .avatar-uploader .el-upload {
        border: 1px dashed #ddd;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    @import '../../assets/css/common.css';
    .el-table--border th, .el-table__fixed-right-patch{
        border-bottom: 1px solid #303133;
    }
    .el-table--border td, .el-table--border th, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
        border-right: 1px solid #303133;
    }
    .el-table td, .el-table th.is-leaf{
        border-bottom: 1px solid #303133;
    }
    .el-table--border, .el-table--group{
        border: 1px solid #303133;
    }
</style>